import { parsePhoneNumber } from 'react-phone-number-input'

/**
 * Parses a phone number string and extracts country code and contact number
 * @param {string} phoneNumber - The phone number string (e.g., "+923001234567")
 * @returns {Object} - { countryCode: string, contact: string }
 */
export const parsePhoneNumberToParts = (phoneNumber) => {
  if (!phoneNumber) {
    return { countryCode: '+92', contact: '' }
  }

  try {
    const parsed = parsePhoneNumber(phoneNumber)
    if (parsed) {
      return {
        countryCode: `+${parsed.countryCallingCode}`,
        contact: parsed.nationalNumber,
      }
    }
  } catch (error) {
    // Fallback: try to extract manually
    const match = phoneNumber.match(/^(\+\d{1,3})(.+)$/)
    if (match) {
      return {
        countryCode: match[1],
        contact: match[2],
      }
    }
  }

  // If all parsing fails, return the original as contact
  return {
    countryCode: '+92',
    contact: phoneNumber,
  }
}

/**
 * Combines country code and contact number into a full phone number string
 * @param {string} countryCode - The country code (e.g., "+92")
 * @param {string} contact - The contact number (e.g., "3001234567")
 * @returns {string} - Combined phone number
 */
export const combinePhoneNumber = (countryCode, contact) => {
  if (!contact) return ''
  if (!countryCode) return contact

  // Remove country code from contact if it's already included
  const cleanContact = contact.replace(countryCode, '')
  return `${countryCode}${cleanContact}`
}
